import React, { useRef, useEffect, useState } from "react";
import { translate } from "../Services/translation";

const BackToTopButton = () => {
    const triggerRef = useRef(null);
    const buttonRef = useRef(null);
    const [showButton, setShowButton] = useState(false);
    const headerHeight = document.querySelector(".js-header")?.offsetHeight;

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
    }, []);

    const handleScroll = () => {
        const el = triggerRef.current;

        if (el.getBoundingClientRect().top < headerHeight) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
    };

    return (
        <div className="back-to-top" ref={triggerRef}>
            <a href="#" className={`button button--orange back-to-top__button ${showButton ? "back-to-top__button--pinned" : ""}`} ref={buttonRef}  >
                {translate("product.showproducts")}
                <svg className="back-to-top__icon">
                    <use href="/ui/images/sprites/be-group.svg#down-arrow"></use>
                </svg>
            </a>
        </div>
    )
};

export default BackToTopButton;